module.exports = __webpack_public_path__ + "static/img/connect_img_append_2.64d027e4.png";